import type { DateValue } from '@internationalized/date';
import { create } from 'zustand';
import type { OmitFunctions } from '@/types';
import { createSelectors } from './selector';

type WeeklySqlViewFiltersState = {
  search: string;
  createdAt: DateValue | undefined;
  createdBy: number | null;
  actionedBy: number | null;
  recordIds: number[];
  type: number | null;
  state: number | null;
  setSearch: (value: string) => void;
  setCreatedAt: (value: DateValue | undefined) => void;
  setCreatedBy: (value: number | null) => void;
  setActionedBy: (value: number | null) => void;
  setRecordIds: (value: number[]) => void;
  setType: (value: number | null) => void;
  setState: (value: number | null) => void;
  resetFilters: () => void;
};

const initialState: OmitFunctions<WeeklySqlViewFiltersState> = {
  search: '',
  createdAt: undefined,
  createdBy: null,
  actionedBy: null,
  recordIds: [],
  type: null,
  state: null,
};

const weeklySqlViewFiltersSlice = create<WeeklySqlViewFiltersState>((set) => ({
  ...initialState,
  setSearch: (value) => set({ search: value }),
  setCreatedAt: (value) => set({ createdAt: value }),
  setCreatedBy: (value) => set({ createdBy: value }),
  setActionedBy: (value) => set({ actionedBy: value }),
  setRecordIds: (value) => set({ recordIds: value }),
  setType: (value) => set({ type: value }),
  setState: (value) => set({ state: value }),
  resetFilters: () => set(initialState),
}));

export const useWeeklySqlViewFilters = createSelectors(weeklySqlViewFiltersSlice);
